import { render } from "./standardDialog.vue?vue&type=template&id=bf87a304&scoped=true"
import script from "./standardDialog.vue?vue&type=script&lang=js"
export * from "./standardDialog.vue?vue&type=script&lang=js"

import "./standardDialog.vue?vue&type=style&index=0&id=bf87a304&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf87a304"]])

export default __exports__